/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
	SignInRequestDto,
	SignUpRequestDto,
	UserChangePasswordRequestDto,
	UserInviteRequestDto,
	UserInviteResponseDto,
	UserResetPasswordChangeRequestDto,
	UserResetPasswordRequestDto,
	UserResponseDto,
	UserSignUpRequestDto,
	UserUpdateRequestDto,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class User<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description 이메일 및 SNS 가입
	 *
	 * @tags /user
	 * @name DoPostUserSignUp
	 * @summary 회원 > 가입
	 * @request POST:/user/signUp
	 * @secure
	 * @response `200` `string` OK
	 * @response `400` `string` 입력 데이터 확인
	 * @response `409` `string` 가입된 이메일
	 * @response `500` `string` 서버 오류
	 */
	doPostUserSignUp = (data: SignUpRequestDto, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/user/signUp`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * @description 이메일 및 SNS 회원 추가
	 *
	 * @tags /user
	 * @name DoPostUserSignUpCrew
	 * @summary 회원 > 추가
	 * @request POST:/user/signUp/crew
	 * @secure
	 * @response `200` `string` OK
	 * @response `400` `string` 이메일 체크
	 * @response `404` `string` 토큰 확인 안됨
	 * @response `409` `string` 가입된 이메일
	 * @response `500` `string` 서버 오류
	 */
	doPostUserSignUpCrew = (data: UserSignUpRequestDto, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/user/signUp/crew`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * @description 이메일 및 SNS 로그인
	 *
	 * @tags /user
	 * @name DoPostUserSignIn
	 * @summary 회원 > 로그인
	 * @request POST:/user/signIn
	 * @secure
	 * @response `200` `string` OK
	 * @response `400` `string` 입력 데이터 확인
	 * @response `404` `string` 회원정보 없음
	 * @response `500` `string` 서버 오류
	 */
	doPostUserSignIn = (data: SignInRequestDto, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/user/signIn`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * @description 이메일 가입 회원 비밀번호 초기화
	 *
	 * @tags /user
	 * @name DoPostUserResetPassword
	 * @summary 회원 > 비밀번호 초기화
	 * @request POST:/user/signIn/resetPassword
	 * @secure
	 * @response `200` `UserInviteResponseDto` OK
	 * @response `400` `UserInviteResponseDto` 입력 데이터 확인
	 * @response `500` `UserInviteResponseDto` 서버 오류
	 */
	doPostUserResetPassword = (
		data: UserResetPasswordRequestDto,
		params: RequestParams = {},
	) =>
		this.http.request<UserInviteResponseDto, UserInviteResponseDto>({
			path: `/user/signIn/resetPassword`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * @description 이메일 가입 회원 비밀번호 변경
	 *
	 * @tags /user
	 * @name DoPatchUserResetPassword
	 * @summary 회원 > 비밀번호 초기화 변경
	 * @request PATCH:/user/signIn/resetPassword
	 * @secure
	 * @response `200` `string` OK
	 * @response `400` `string` 입력 데이터 확인
	 * @response `404` `string` 회원정보 없음
	 * @response `500` `string` 서버 오류
	 */
	doPatchUserResetPassword = (
		data: UserResetPasswordChangeRequestDto,
		params: RequestParams = {},
	) =>
		this.http.request<string, string>({
			path: `/user/signIn/resetPassword`,
			method: "PATCH",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * @description owner 이외의 사용자를 초대합니다.
	 *
	 * @tags /user
	 * @name DoPostUserInvite
	 * @summary 회원 > 사용자 초대
	 * @request POST:/user/invite
	 * @secure
	 * @response `200` `(UserInviteResponseDto)[]` OK
	 * @response `400` `(UserInviteResponseDto)[]` 입력 데이터 확인
	 * @response `406` `(UserInviteResponseDto)[]` 오너가 아닌 사람이 초대 할 경우
	 */
	doPostUserInvite = (data: UserInviteRequestDto, params: RequestParams = {}) =>
		this.http.request<UserInviteResponseDto[], UserInviteResponseDto[]>({
			path: `/user/invite`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /user
	 * @name DoPostUserChangePassword
	 * @summary 회원 > 비밀번호 변경
	 * @request POST:/user/changePassword
	 * @secure
	 * @response `200` `string` OK
	 * @response `400` `string` 입력 데이터 확인
	 * @response `404` `string` 이전 암호 불일치
	 * @response `500` `string` 서버 오류
	 */
	doPostUserChangePassword = (
		data: UserChangePasswordRequestDto,
		params: RequestParams = {},
	) =>
		this.http.request<string, string>({
			path: `/user/changePassword`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /user
	 * @name DoGetUser
	 * @summary 회원 > 내 정보 상세
	 * @request GET:/user
	 * @secure
	 * @response `200` `UserResponseDto` OK
	 * @response `500` `UserResponseDto` 서버 오류
	 */
	doGetUser = (params: RequestParams = {}) =>
		this.http.request<UserResponseDto, UserResponseDto>({
			path: `/user`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description 이름 및 암호 변경
	 *
	 * @tags /user
	 * @name DoPatchUser
	 * @summary 회원 > 수정
	 * @request PATCH:/user
	 * @secure
	 * @response `200` `string` OK
	 * @response `400` `string` 토큰 복호화 안됨
	 * @response `404` `string` 토큰 확인 안됨
	 * @response `500` `string` 서버 오류
	 */
	doPatchUser = (data: UserUpdateRequestDto, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/user`,
			method: "PATCH",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * @description 오너 권한 위임
	 *
	 * @tags /user
	 * @name DoPatchUserOwnerId
	 * @summary 회원 > 오너 변경
	 * @request PATCH:/user/owner/{id}
	 * @secure
	 * @response `200` `string` OK
	 * @response `404` `string` 회원이 존재하지 않거나, 다른 회사 유저일 경우
	 * @response `406` `string` 오너가 아님
	 * @response `409` `string` 변경 대상이 오너인 경우
	 * @response `500` `string` 서버 오류
	 */
	doPatchUserOwnerId = (id: number, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/user/owner/${id}`,
			method: "PATCH",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /user
	 * @name DoGetUserList
	 * @summary 회원 > 리스트
	 * @request GET:/user/list
	 * @secure
	 * @response `200` `(UserResponseDto)[]` OK
	 * @response `500` `(UserResponseDto)[]` 서버 오류
	 */
	doGetUserList = (params: RequestParams = {}) =>
		this.http.request<UserResponseDto[], UserResponseDto[]>({
			path: `/user/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description 계정 탈퇴
	 *
	 * @tags /user
	 * @name DoDeleteUser
	 * @summary 회원 > 탈퇴(오너는 삭제 불가)
	 * @request DELETE:/user/{id}
	 * @secure
	 * @response `200` `string` OK
	 * @response `404` `string` 삭제하려는 회원이 존재하지 않음
	 * @response `406` `string` 오너 또는 본인이 아닌 사람이 삭제 할 경우
	 * @response `500` `string` 서버 오류
	 */
	doDeleteUser = (id: number, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/user/${id}`,
			method: "DELETE",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description 이메일 및 SNS 가입
	 *
	 * @tags /user
	 * @name DoDeleteUserWithdraw
	 * @summary 회원 > 오너 탈퇴
	 * @request DELETE:/user/withdraw
	 * @secure
	 * @response `200` `string` OK
	 * @response `303` `string` 결제 플랜이 활성화 되어있음(CP 타입)
	 * @response `409` `string` 앱이 1개이상 (AP 타입)
	 * @response `500` `string` 서버 오류
	 */
	doDeleteUserWithdraw = (params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/user/withdraw`,
			method: "DELETE",
			secure: true,
			format: "json",
			...params,
		});
}
